/**
 * TimeFieldButton - Time field button using existing hooks
 */

import {useDateTime} from '@hconnect/tuc-processes/fields/dateTime/useDateTime'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {formattedDate} from '../../../../../../../Pages/Order/OrderDetails/components/utils'
import {FieldButton} from '../../FieldButton'

interface TimeFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const TimeFieldButton: React.FC<TimeFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t, i18n} = useTranslation()
  const {dateTime} = useDateTime()

  // Following useRmcOrderEditLogic pattern - formattedDate returns [date, time]
  const displayValue = dateTime && dateTime[0] ? formattedDate(dateTime[0], i18n.language)[1] : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.time', 'Start time')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
